import { render } from "./StockTakeDetailsAddView.vue?vue&type=template&id=79050862"
import script from "./StockTakeDetailsAddView.vue?vue&type=script&lang=js"
export * from "./StockTakeDetailsAddView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__